import {
    FETCH_SEARCH_DETAILS_BEGIN,
    FETCH_SEARCH_DETAILS_SUCCESS,
    FETCH_SEARCH_DETAILS_FAILURE,
    FILTER_BY_BRAND,
    RESET_STATE,
    FETCH_SEARCH_COUNT_BEGIN,
    FETCH_SEARCH_COUNT_SUCCESS,
    FETCH_SEARCH_COUNT_FAILURE,
    FETCH_SEARCH_URLS_BEGIN,
    FETCH_SEARCH_URLS_SUCCESS,
    FETCH_SEARCH_URLS_FAILURE,
    GET_PRODUCT_LIST_SUCCESS,
    GET_PRODUCT_LIST_BEGIN,
    GET_PRODUCT_LIST_FAILURE
} from '../constants/searchDetailsActionTypes';
import { config } from '../env_config/react-config';

const initialState = {
    isLoading: true,
    searchResults: [],
    selectedBrand: '',
    page: 0,
    searchCount: 0,
    isSearchCountLoading: true,
    isFetchLoading: false,
    error: {},
    productList: [],
    isProductListLoading: config.non_latin_language ? true : false
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch(action.type){
        case FETCH_SEARCH_DETAILS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case FETCH_SEARCH_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                searchResults: action.payload.page === 0 ? action.payload.result : [...state.searchResults, ...action.payload.result],
                page: action.payload.page+1
            }
        case FETCH_SEARCH_DETAILS_FAILURE:
            return {
                ...state,
                isLoading: false,
                searchResults: []
            }
        case FILTER_BY_BRAND:
            return {
                ...state,
                selectedBrand: action.payload
            }
        case RESET_STATE:
            return initialState;
        case FETCH_SEARCH_COUNT_BEGIN:
            return {
                ...state,
                isSearchCountLoading: true
            }
        case FETCH_SEARCH_COUNT_SUCCESS:
            return {
                ...state,
                searchCount: action.payload.result_count === undefined ? 0 :  action.payload.result_count,
                isSearchCountLoading: false
            }
        case FETCH_SEARCH_COUNT_FAILURE:
            return {
                ...state,
                searchCount: 0,
                isSearchCountLoading: false
            }
        case FETCH_SEARCH_URLS_BEGIN:
            return {
                ...state,
                isFetchLoading: true,
            }
        case FETCH_SEARCH_URLS_SUCCESS:
            return {
                ...state,
                searchCount: action.payload.searchCount,
                isFetchLoading: false,
                searchResults: action.payload.searchResults,
                page: 1
            }
        case FETCH_SEARCH_URLS_FAILURE:
            return {
                ...state,
                searchCount: 0,
                isFetchLoading: false,
                searchResults: [],
                page: 0
            }
        case GET_PRODUCT_LIST_SUCCESS:
            return {
              ...state,
              productList: action.productList,
              isProductListLoading: false
            }
        case GET_PRODUCT_LIST_BEGIN:
            return {
              ...state,
              isProductListLoading: true
            }
        case GET_PRODUCT_LIST_FAILURE:
            return {
              ...state,
              isProductListLoading: false
            }
        default:
            return state;
    }
}
